// TODO(ayson): 逐步整理到 '@/utils/localStorage'
export enum LocalStorage {
  /**
   * 藝術家版本的 Design Page 用
   */
  ArtistIdForCustomization = 'artist_id_for_customization',
  /**
   * 測試環境為了結帳用的
   */
  Checkout = 'checkout',
  /**
   * 使用者的設計資料
   */
  DesignConfig = 'design_config',
  /**
   * 設計的客製化程度
   */
  DesignCustomizationLevel = 'design_customization_level',
  /**
   * 最愛的作品
   */
  FavoriteArtwork = 'favorite_artwork',
  /**
   * 上傳的圖檔
   */
  Photo = 'photo',

  /**
   * design page 貼圖最近使用
   */
  RecentStickerGroup = 'recent_sticker_group',
  /**
   * 讓 staging 跟 local 可以連上 prod 測試正式資料用的
   */
  ViteGraphqlEndpointURL = 'VITE_GRAPHQL_ENDPOINT_URL',
}

export enum SessionStorage {
  /**
   * design page FAQ 顯示的 modal
   */
  FAQModalNotShow = 'faq_modal_not_show',
}
